import React, { Component } from "react";
import wishlist from '../../components/wishlist';
import toast from '../../components/toast';
import { postGetTranslations } from '../../apis/translations';

class ProductWishlistBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isInWishlist: false,
            isLoading: false,
            translationLookup: {} 
        };

        this.handleWishlistClick = this.handleWishlistClick.bind(this);
    }


    componentWillMount() {
        let translationKeys = {
            WhisListRemoved: 'ProductItem.Text.WhisListRemoved',
            WhisListRemovedError: 'ProductItem.Text.WhisListRemovedError',
            WhisListAdded: 'ProductItem.Text.WhisListAdded',
            WhisListAddedError: 'ProductItem.Text.WhisListAddedError',
            BtnAddWishList: 'ProductItem.Text.BtnAddWishList',
       
        };

        // Fetch translations and update state
        postGetTranslations([
            translationKeys.WhisListRemoved,
            translationKeys.WhisListRemovedError,
            translationKeys.WhisListAdded,
            translationKeys.WhisListAddedError,
            translationKeys.BtnAddWishList,
        ]).then(translations => {
            this.setState({
                translationLookup: {
                    WhisListRemoved: translations[translationKeys.WhisListRemoved] ?? 'Removed from your wish list',
                    WhisListRemovedError: translations[translationKeys.WhisListRemovedError] ?? 'There was an error trying to remove this product from your wish list',
                    WhisListAdded: translations[translationKeys.WhisListAdded] ?? 'Added to your wish list',
                    WhisListAddedError: translations[translationKeys.WhisListAddedError] ?? 'There was an error trying to add this product to your wish list',
                    BtnAddWishList: translations[translationKeys.BtnAddWishList] ?? 'Add to Wish List'
                }
            });
        }).catch(error => {
            console.log(error);
        });


        wishlist.hasProduct(this.props.id).then(result => this.setState({
            isInWishlist: result
        }));
    }

    handleWishlistClick(e) {
        wishlist.hasProduct(this.props.id).then(result => {
            this.setState({
                isInWishlist: result,
                isLoading: true
            });
            if (result) {
                wishlist.delete(this.props.id)
                    .then(data => {
                        toast.success(this.state.translationLookup.WhisListRemovedError);
                        this.setState({
                            isInWishlist: false
                        });
                    })
                    .catch(error => {
                        toast.error(this.state.translationLookup.WhisListAddedError);
                    })
                    .finally(() => {
                        this.setState({
                            isLoading: false
                        });
                    });
            }
            else {
                wishlist.add(this.props.id)
                    .then(data => {
                        toast.success(this.state.translationLookup.WhisListAdded);
                        this.setState({
                            isInWishlist: true
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error(this.state.translationLookup.WhisListAddedError);
                    })
                    .finally(() => {
                        this.setState({
                            isLoading: false
                        });
                    });
            }
        });
    }

    render() {
        let wishlistBtn = <button class={`btn btn-outline-alt ${this.props.btnClass}`} type="button" onClick={this.handleWishlistClick} disabled={this.state.isLoading}>
            <svg className="icon icon-heart"><use xlinkHref="#icon-heart"></use></svg>
            <span>{this.state.translationLookup.BtnAddWishList}</span>
        </button>;

        if (this.state.isInWishlist) {
            wishlistBtn = <button class={`btn btn-outline-alt ${this.props.btnClass}`} type="button" onClick={this.handleWishlistClick} disabled={this.state.isLoading}>
                <svg className="icon icon-heart-filled"><use xlinkHref="#icon-heart-filled"></use></svg>
                <span>{this.state.translationLookup.WhisListAdded}</span>
            </button>;
        }

        return wishlistBtn;
    }
}

export default ProductWishlistBtn;